import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './RectangleIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const RectangleIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function RectangleIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 24 24" component={Icon} {...props} />
  );
});
